import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const Radio = React.forwardRef(function Radio({ label, description, descriptionId, className, id, ...rest }, ref) {
    return (_jsxs("label", { className: className, "data-radio": true, htmlFor: id, style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 'var(--space-3)',
            padding: 'var(--space-2)',
            minHeight: 'var(--min-touch-target)',
            cursor: 'pointer',
            color: 'var(--text)',
            fontFamily: 'var(--font-ui)',
            fontSize: 'var(--font-size-2xs)',
        }, children: [_jsx("input", { ref: ref, type: "radio", id: id, style: { width: '18px', height: '18px', marginTop: '2px', accentColor: 'var(--accent)' }, ...rest }), _jsxs("span", { style: { display: 'grid', gap: '2px' }, children: [_jsx("span", { children: label }), description ? (_jsx("span", { id: descriptionId, style: { color: 'var(--text-muted)', fontSize: 'var(--font-size-3xs)' }, children: description })) : null] })] }));
});
//# sourceMappingURL=Radio.js.map